import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { AddUser } from 'src/app/shared/ngxs/action/management.action';
import { OperationMode, UserType } from './../../shared/models/enum.model';
import { AddUserModel, UserModel } from './../../shared/models/user.model';
import { EditUser } from './../../shared/ngxs/action/management.action';

@Component({
  selector: 'app-manage-user',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.scss'],
})
export class ManageUserComponent implements OnInit {
  model: AddUserModel;
  opModes = OperationMode;
  opMode = OperationMode.Create;
  editmodel: UserModel;
  userTypes = UserType;
  userTypesEnumValues = Object.values(UserType).filter(
    (type) => isNaN(<any>type) && type !== 'values'
  );
  constructor(private store: Store, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.model = new AddUserModel();
    if (data) {
      this.editmodel = data.editModel;
      this.opMode = data.mode;
      if (this.opMode === OperationMode.Edit) {
        this.model.firstname = this.editmodel.firstname;
        this.model.lastname = this.editmodel.lastname;
        this.model.type = UserType[this.editmodel.roles[0]];
      }
    }
  }

  ngOnInit(): void {}

  onConfirm() {
    this.model.username = this.model.firstname + this.model.lastname;
    if (this.opMode === OperationMode.Create) {
      this.store.dispatch(new AddUser(this.model));
    } else if (this.opMode === OperationMode.Edit) {
      let updated = new UserModel();
      updated = Object.assign({}, this.editmodel);
      updated.firstname = this.model.firstname;
      updated.lastname = this.model.lastname;
      updated.roles = []; //always we will work with one role
      updated.roles.push(UserType[this.model.type].toString());
      this.store.dispatch(new EditUser(updated));
    }
  }
}
